<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
    :class="{
      rtl: $i18n.locale === 'fa' || $i18n.locale === 'ar',
      ltr: $i18n.locale === 'en',
    }"
  >
    <template>
      <v-row no-gutters>
        <custom-popup
          v-model="dialog"
          :cons="cons"
          class="rounded-xl"
          max-width="480"
        >
          <template v-if="['start_time', 'end_time'].includes(action)">
            <v-card class="rounded-xl" flat>
              <v-card-title class="justify-center">{{
                settingsComponents[action].title
              }}</v-card-title>
              <v-card-text>
                <component
                  :is="settingsComponents[action].component"
                  v-if="dialog && !!action"
                  v-model="computedValue[action]"
                  :min="
                    action === 'start_time'
                      ? computedNowDate
                      : computedValue['start_time']
                  "
                  dense
                  outlined
                  wrapper-class="rounded-lg contentinfo"
                />
              </v-card-text>
            </v-card>
          </template>
          <component
            v-else-if="dialog && !!action"
            :is="settingsComponents[action].component"
            v-model="computedValue[action]"
          />
        </custom-popup>

        <v-col
          v-for="(item, i) in computedValue"
          :key="i"
          class="pa-2"
          cols="12"
          md="6"
        >
          <v-card class="rounded-lg" outlined @click="editItem(item, i)">
            <v-list-item three-line>
              <v-list-item-icon class="align-self-center">
                <v-icon>{{ settingsComponents[i].icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title class="font-size-h6 font-weight-bold">
                  {{ settingsComponents[i].title }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ submitField({ name: settingsComponents[i] }) }}
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action class="align-self-center">
                <v-icon>mdi-cog-outline</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import CustomDatePicker from "@/core/plugins/TitleRibbon/pages/pickers/custom-date-picker.vue";
import dsFunctionType from "@/view/pages/qrland/components/qrManage/manageShop/discountSettings/dsFunctionType.vue";
import dsBasketCondition from "@/view/pages/qrland/components/qrManage/manageShop/discountSettings/dsBasketCondition.vue";
import dsUserSettings from "@/view/pages/qrland/components/qrManage/manageShop/discountSettings/dsUserSettings.vue";
import dsLimitationUse from "@/view/pages/qrland/components/qrManage/manageShop/discountSettings/dsLimitationUse.vue";

export default {
  name: "discountSettingsEditor",
  components: {
    CustomDatePicker,
    dsFunctionType,
    dsBasketCondition,
    dsUserSettings,
    dsLimitationUse,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      helpData: [],
      componentName: "discountSettingsEditor",
      serviceName: "Qrland",
      cons: {
        title: "",
        buttons: [{ type: "submit", handler: () => this.submitField }],
      },
      dialog: false,
      action: "",
      settings: {
        FunctionType: { name: "AllShoppingCart" },
        BasketCondition: { name: "NoConditions" },
        UserSettings: { name: "AllUser" },
        LimitationUse: { name: "NoLimitations" },
        start_time: "",
        end_time: "",
      },
    };
  },
  computed: {
    settingsComponents() {
      return {
        FunctionType: {
          title: this.$t("discount_settings.function_type.title"),
          icon: "mdi-tag-arrow-left-outline",
          component: "dsFunctionType",
          name: "FunctionType",
        },
        BasketCondition: {
          title: this.$t("discount_settings.basket_condition.title"),
          icon: "mdi-basket-outline",
          component: "dsBasketCondition",
          name: "BasketCondition",
        },
        UserSettings: {
          title: this.$t("discount_settings.user_settings.title"),
          icon: "mdi-account-outline",
          component: "dsUserSettings",
          name: "UserSettings",
        },
        LimitationUse: {
          title: this.$t("discount_settings.limitation_use.title"),
          icon: "mdi-tune",
          component: "dsLimitationUse",
          name: "LimitationUse",
        },
        start_time: {
          title: this.$t("discount_settings.start_time.title"),
          icon: "mdi-calendar-range-outline",
          component: "CustomDatePicker",
          name: "start_time",
        },
        end_time: {
          title: this.$t("discount_settings.end_time.title"),
          icon: "mdi-calendar-range-outline",
          component: "CustomDatePicker",
          name: "end_time",
        },
      };
    },
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    computedNowDate() {
      const moment = require("moment-jalaali");
      return moment().format("YYYY-MM-DD HH:mm:ss");
    },
  },
  mounted() {
    if (!this.value) {
      this.computedValue = {
        ...this.settings,
        start_time: this.computedNowDate,
        end_time: this.computedNowDate,
      };
    }
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    editItem(item, name) {
      this.cons.title = this.settingsComponents[name].title;
      this.action = name;
      this.$nextTick(() => {
        this.dialog = true;
      });
    },
    submitField({ name }) {
      let text = "";
      switch (name.name) {
        case "FunctionType":
          {
            const items = [
              {
                value: "AllShoppingCart",
                text: this.$t(
                  "discount_settings.function_type.all_shopping_cart"
                ),
              },
              {
                value: "SpecialProducts",
                text: this.$t(
                  "discount_settings.function_type.special_products"
                ),
              },
              {
                value: "SpecialCategories",
                text: this.$t(
                  "discount_settings.function_type.special_categories"
                ),
              },
            ];
            text =
              items.find((item) => item.value === this.value.FunctionType.name)
                ?.text || "";
          }
          break;
        case "BasketCondition":
          {
            const items = [
              {
                value: "NoConditions",
                text: this.$t(
                  "discount_settings.basket_condition.no_conditions"
                ),
              },
              {
                value: "MinimumShopping",
                text: this.$t(
                  "discount_settings.basket_condition.minimum_shopping"
                ),
              },
              {
                value: "MinimumProduct",
                text: this.$t(
                  "discount_settings.basket_condition.minimum_product"
                ),
              },
              {
                value: "MaximumShopping",
                text: this.$t(
                  "discount_settings.basket_condition.maximum_shopping"
                ),
              },
              {
                value: "MaximumProduct",
                text: this.$t(
                  "discount_settings.basket_condition.maximum_product"
                ),
              },
            ];
            text =
              items.find(
                (item) => item.value === this.value.BasketCondition.name
              )?.text || "";
          }
          break;
        case "UserSettings":
          {
            const items = [
              {
                value: "AllUser",
                text: this.$t("discount_settings.user_settings.all_user"),
              },
              {
                value: "group",
                text: this.$t("discount_settings.user_settings.group"),
              },
              {
                value: "special",
                text: this.$t("discount_settings.user_settings.special"),
              },
            ];
            text =
              items.find((item) => item.value === this.value.UserSettings.name)
                ?.text || "";
          }
          break;
        case "LimitationUse":
          {
            const items = [
              {
                value: "NoLimitations",
                text: this.$t(
                  "discount_settings.limitation_use.no_limitations"
                ),
              },
              {
                value: "DiscountCode",
                text: this.$t("discount_settings.limitation_use.discount_code"),
              },
              {
                value: "User",
                text: this.$t("discount_settings.limitation_use.user"),
              },
            ];
            text =
              items.find((item) => item.value === this.value.LimitationUse.name)
                ?.text || "";
          }
          break;
        case "start_time":
          {
            if (this.value.start_time && this.value.start_time.length > 0) {
              const moment = require("moment-jalaali");
              text = moment(this.value.start_time, "YYYY-MM-DD HH:mm:ss").format("jYYYY/jMM/jDD HH:mm");
            } else {
              text = this.$t("discount_settings.start_time.no_time_selected");
            }
          }
          break;
        case "end_time":
          {
            if (this.value.end_time && this.value.end_time.length > 0) {
              const moment = require("moment-jalaali");
              text = moment(this.value.end_time, "YYYY-MM-DD HH:mm:ss").format("jYYYY/jMM/jDD HH:mm");
            } else {
              text = this.$t("discount_settings.end_time.no_time_selected");
            }
          }
          break;
      }
      return text;
    },
  },
};
</script>

<style scoped>
.rtl {
  direction: rtl;
}
.ltr {
  direction: ltr;
}
.v-card {
  transition: all 0.3s;
}
</style>
